import React from "react";

export const DASHBOARD_CHART_OPTIONS = {
    transitions: true,
    seriesColors: ["#2785ff", "#ffa340", "#24b993", "#8c72ed", "#1cb6cc"],
    axisDefaults: {
        labels: { color: "#587198", font: "11px Segoe UI, sans-serif" },
        line: { color: "#e3ebf5" },
        majorGridLines: { color: "#edf2f8" },
    },
};

export const dashboardActionStyle = {
    borderRadius: 7,
    border: "1px solid #dfe7f1",
    background: "#ffffff",
    color: "#173767",
    padding: "7px 9px",
    boxShadow: "0 2px 4px rgba(16, 37, 87, 0.05)",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
};

export const DashboardChartSkeleton = () => (
    <div className="wm-chart-skeleton" aria-label="Loading chart" role="status">
        <div className="wm-chart-skeleton__legend">
            <span />
            <span />
            <span />
        </div>
        <div className="wm-chart-skeleton__plot">
            <span style={{ height: "42%" }} />
            <span style={{ height: "68%" }} />
            <span style={{ height: "50%" }} />
            <span style={{ height: "78%" }} />
            <span style={{ height: "58%" }} />
            <span style={{ height: "86%" }} />
            <span style={{ height: "46%" }} />
            <span style={{ height: "70%" }} />
        </div>
        <span className="wm-chart-skeleton__label">Loading chart data...</span>
    </div>
);

const DashboardChartCard = ({ title, subtitle, icon = "fa-chart-line", actions, loading = false, children }) => (
    <section className="wm-chart-card" aria-label={title}>
        <div className="wm-chart-card__header">
            <i className={"fa-solid " + icon} aria-hidden="true" />
            <div className="wm-chart-card__heading">
                <h2>{title}</h2>
                {subtitle && <p>{subtitle}</p>}
            </div>
            <div className="wm-chart-card__actions">{actions}</div>
        </div>
        <div className="wm-chart-card__body">{loading ? <DashboardChartSkeleton /> : children}</div>
    </section>
);

export default DashboardChartCard;
